import { useQuery } from '@tanstack/react-query';
import { fetchSupportChatConversation } from './request';
import { supportChatKeys } from './key';

export const useSupportChatConversation = (enabled: boolean) => {
  return useQuery({
    queryKey: supportChatKeys.conversation(),
    queryFn: fetchSupportChatConversation,
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
